import React from 'react';
import type { FieldProps } from './Field';

interface NumberFieldProps extends FieldProps<number> {
  minimum?: number;
  maximum?: number;
}

const NumberField: React.FC<NumberFieldProps> = ({ 
    label, 
    value,
    minimum,
    maximum,
    onChange,
    onBlur
  }) => {
    return (
      <div style={{ marginBottom: '1rem' }}>
        {label && <label style={{ display: 'block', marginBottom: '0.25rem' }}>{label}</label>}
        <input
          type='number'
          value={value}
          min={minimum}
          max={maximum}
          style={{ width: '100%', padding: '0.5rem', borderRadius: '4px', border: '1px solid #ccc' }}
          onChange={(e) => onChange(Number(e.target.value))}
          onBlur={(e) => onBlur?.(Number((e.target as HTMLInputElement).value))}
        />

        {(minimum !== undefined || maximum !== undefined) && (
          <div style={{ 
            fontSize: '0.75rem', 
            color: '#666', 
            marginTop: '0.25rem',
            display: 'flex',
            justifyContent: 'space-between'
          }}>
            <span>Min: {minimum}</span>
            <span>Max: {maximum}</span>
          </div>
        )}
      </div>
    );
  };
  
export default NumberField;